<form [formGroup]="GenralInfoForm">
<app-calculation-type *ngIf="isPipeSpec" [form]="GenralInfoForm" [disable]="true" class="calculation-component"></app-calculation-type>

    <app-permit-washers [form]="GenralInfoForm" class="calculation-component"></app-permit-washers>
</form>
